MxObjectsHierarchyPickerCtrl.$inject = [
	'$scope',
	'$q',
	'$element',
	'$timeout',
	'mx.SolutionBuilderAgent.EntityService',
	'mx.internationalization',
	'mx.SolutionBuilderAgent.DialogOpenerService',
	'mx.SolutionBuilderAgent.mxColumnDefinitionService',
	'mx.SolutionBuilderAgent.ExternalServiceManager',
	'mx.shell.KeyboardNavigationService',
	'mx.SolutionBuilderAgent.ContentWidgetService',
	'$attrs',
];

function MxObjectsHierarchyPickerCtrl(
	$scope,
	$q,
	$element,
	$timeout,
	mxEntityService,
	i18n,
	dialogOpener,
	columnDefinition,
	externalServiceManager,
	keyboardNavigationService,
	contentWidgetService,
	$attrs
) {
	const vm = this;

	vm.$onInit = function () {
		vm.includeRoot = true;

		window.mx.SolutionBuilderAgent.ObjectPickerCtrl.call(
			vm,
			$scope,
			$q,
			$element,
			$timeout,
			mxEntityService,
			i18n,
			dialogOpener,
			columnDefinition,
			externalServiceManager,
			keyboardNavigationService,
			contentWidgetService,
			$attrs
		);

		//init the base class
		vm.$onInit.call(vm);

		// Override default method
		vm.setAdditionalOutputs = function (item, onChangeData) {
			if (onChangeData) {
				const chain = onChangeData.selectedItemChain;
				const lastChainItem = Array.isArray(chain) ? chain[chain.length - 1] : undefined;
				vm.objectId = lastChainItem ? lastChainItem._id : null;
				vm.displayString = lastChainItem ? lastChainItem._displayName : null;
			}
		};

		if (vm.noBrowseLookup !== 'true') {
			vm.browseLookup = browseLookup;
		}
	};

	function browseLookup(selectedItem) {
		return vm.entityClassName
			? dialogOpener.selectHierarchyObject(
					vm.entityClassName,
					vm.label,
					vm.parentViewController && vm.parentViewController.mxView,
					vm.parentExpression,
					selectedItem,
					vm.filterExpression,
					vm.rootElement,
					vm.includeRoot,
					vm.displayExpression,
					vm.columnDefinition
			  )
			: $q.when(selectedItem);
	}

	vm.loadTree = function (searchText, id, parentId) {
		const extraParams = {};
		if (id) {
			extraParams.ids = [id];
			searchText = '';
		} else if (parentId) {
			extraParams.ids = [parentId];
			searchText = searchText || 'A';
		}
		const skipFilter = !searchText;
		return searchText || extraParams.ids
			? vm.loadItems(searchText, undefined, undefined, extraParams, skipFilter).then(function (res) {
					return res.items.map(function (node) {
						return {
							id: node.Id,
							title: node.DisplayString,
							// These params are needed to be able to open this object preview dialog
							_id: node.ObjectId,
							_type: node.EntityType,
							_displayName: node.DisplayString,
							__parents:
								node.Parents &&
								node.Parents.map(function (pNode) {
									return {
										id: pNode.Id,
										title: pNode.DisplayString,
										// These params are needed to be able to open this object preview dialog
										_id: pNode.ObjectId,
										_type: pNode.EntityType,
										_displayName: pNode.DisplayString,
									};
								}),
						};
					});
			  })
			: $q.when([]);
	};
}

angular.module('mx.SolutionBuilderAgent').directive('mxObjectHierarchyPicker', function mxObjectHierarchyPickerDirective() {
	const directive = window.mx.SolutionBuilderAgent.ObjectPicker.getDirectiveDescriptor(MxObjectsHierarchyPickerCtrl, 'mx-hierarchy-picker');

	angular.extend(directive.bindToController, window.mx.SolutionBuilderAgent.ObjectPicker.commonObjectPickerProperties);
	directive.bindToController.objectId = '=?';
	directive.bindToController.displayString = '=?';
	directive.bindToController.rootElement = '@?';

	directive.template =
		'<mx-hierarchy-picker ' +
		'label="{{vm.label}}" ' +
		'name="{{vm.name}}" ' +
		'hint="{{vm.hint}}" ' +
		'ng-model="vm.model" ' +
		'data-require="vm.required || vm.ngRequired" ' +
		'data-disabled="vm.disabled" ' + // `data-` prefix is needed for `disabled` attr to be able to work in IE
		'read-only="vm.readOnly" ' +
		'on-change="vm.onChange(onChangeData)" ' +
		'input-data-type="list" ' +
		'load-tree="vm.loadTree" ' +
		'navigate-item="vm.navigateSelectedItem" ' +
		'custom-validation="vm.customValidation"' +
		'browse-lookup="vm.browseLookup"> ' +
		'</mx-hierarchy-picker>';

	return directive;
});
